import article from './article';
import pic from './pic';
import tag from './tag';
import exchange from './exchange';
import announce from './announce';
import ad from './ad';
import journal from './journal';

export default {
    content: { routerName: '内容管理' },
    ...article,
    ...pic,
    ...tag,
    ...exchange,
    ...announce,
    ...ad,
    ...journal,
};
